function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.stcloud10{fill-rule:evenodd;clip-rule:evenodd;fill:#FEEAE0;stroke:none;}\n\t.stcloud11{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#FCC5A8;stroke:none;}\n\t.stcloud12{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#F7ACC2;stroke:none;}\n\t.stcloud13{clip-path:url(#SVGID_6_);fill-rule:evenodd;clip-rule:evenodd;fill:#EA9BC3;stroke:none;}\n\t.stcloud14{clip-path:url(#SVGID_8_);fill-rule:evenodd;clip-rule:evenodd;fill:#75CEDA;stroke:none;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Cloud_2_Clip_7"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1_",
  className: "stcloud10",
  d: "M85.5,355c65.1,12.3,142.6,18,164,15c61.3-8.5,122.3-22.8,172-25c62.3-2.8,195.1,41.9,288-1 c46.4-21.4,65.1-48,70-68c6.9-28-5.7-56.1-16-72c-29.4-45.5-89.3-62.9-146-58c-13.7-56.9-50.2-109.4-106-133 c-78.2-33.1-180.3-2.4-239,83c-22.3-13.6-47.4-20.3-72-16c-48.5,8.5-91,59.3-95,130c-23.2-13.3-53.1-17.8-76-4 c-36,21.7-36.1,78.7-16,110C30.9,343.1,62.4,350.6,85.5,355z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_1_",
  d: "M85.5,355c65.1,12.3,142.6,18,164,15c61.3-8.5,122.3-22.8,172-25c62.3-2.8,195.1,41.9,288-1 c46.4-21.4,65.1-48,70-68c6.9-28-5.7-56.1-16-72c-29.4-45.5-89.3-62.9-146-58c-13.7-56.9-50.2-109.4-106-133 c-78.2-33.1-180.3-2.4-239,83c-22.3-13.6-47.4-20.3-72-16c-48.5,8.5-91,59.3-95,130c-23.2-13.3-53.1-17.8-76-4 c-36,21.7-36.1,78.7-16,110C30.9,343.1,62.4,350.6,85.5,355z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "stcloud11",
  d: "M-46.5,263c34.6-21.4,60-37.1,95-36c51.8,1.6,72.3,38.1,122,28c24.4-5,33.2-16.6,59-14 c24.7,2.5,28.9,14.4,52,14c24.5-0.5,28.9-14.1,54-15c22.1-0.8,26.7,9.4,47,13c41.3,7.3,52.3-31.5,101-35 c34.2-2.4,67.9,13.4,82,20c26,12.2,36.8,24,55,21c18.5-3.1,21.9-17.7,40-31c34.1-24.9,93.6-25.5,131,3c30,22.9,37,58,40,73 c12.5,62.4-16.6,115.9-26,132c-96.7,166.1-420.1,232.4-693,170c-32.8-7.5-292.5-67.2-298-176C-189.5,351.4-59.6,271.1-46.5,263z"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_3_",
  d: "M85.5,355c65.1,12.3,142.6,18,164,15c61.3-8.5,122.3-22.8,172-25c62.3-2.8,195.1,41.9,288-1 c46.4-21.4,65.1-48,70-68c6.9-28-5.7-56.1-16-72c-29.4-45.5-89.3-62.9-146-58c-13.7-56.9-50.2-109.4-106-133 c-78.2-33.1-180.3-2.4-239,83c-22.3-13.6-47.4-20.3-72-16c-48.5,8.5-91,59.3-95,130c-23.2-13.3-53.1-17.8-76-4 c-36,21.7-36.1,78.7-16,110C30.9,343.1,62.4,350.6,85.5,355z"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "stcloud12",
  d: "M-30.5,306c4.6-9.5,13.4-28,33.2-41.5c24-16.4,50-15.8,54.6-15.6c40.3,1.4,45.4,29.3,84.2,34.1 c30.6,3.8,31.6-13,77-17c31.9-2.8,34.3,5.3,92,9c29.1,1.9,50.6,3.3,77-1c42.1-6.8,46.4-19.9,77-27c78.5-18.1,120.4,51.7,183,27 c26.3-10.4,23-24.3,54.8-34.1c4.1-1.3,61-18,98.1,14.3c10,8.7,15.1,18,17.2,21.8c23.4,43.4,23.2,146.7-17.2,203.9 c-51.2,72.3-150.9,48.3-534,33c-216.6-8.6-348.5-7.5-363-60C-100.2,440.3-93.4,437.2-30.5,306z"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_5_",
  d: "M85.5,355c65.1,12.3,142.6,18,164,15c61.3-8.5,122.3-22.8,172-25c62.3-2.8,195.1,41.9,288-1 c46.4-21.4,65.1-48,70-68c6.9-28-5.7-56.1-16-72c-29.4-45.5-89.3-62.9-146-58c-13.7-56.9-50.2-109.4-106-133 c-78.2-33.1-180.3-2.4-239,83c-22.3-13.6-47.4-20.3-72-16c-48.5,8.5-91,59.3-95,130c-23.2-13.3-53.1-17.8-76-4 c-36,21.7-36.1,78.7-16,110C30.9,343.1,62.4,350.6,85.5,355z"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "stcloud13",
  d: "M-17.5,298.3c24.4-23.9,67.9-18.4,76-17.3c37.5,4.7,41,23.7,75,26.3c36.4,2.8,40-18.2,79-19 c43.5-0.9,48.6,25.1,97,27.7c29.3,1.5,53.6-6.6,83.7-16.6c45-15,58.3-29.6,83.3-23.4c20.8,5.1,20.1,17.3,44,23 c27,6.5,33.7-7.7,63-4c35.3,4.5,40.3,26.9,62,22c19.2-4.3,19.1-22.7,50-40c14.3-8,26.6-11,35-13c13.3-3.2,56.9-13.7,89,4.3 c39.2,22,53.1,82.2,42,125c-17.7,68.1-99.2,97.7-149,115c-121.4,42.2-175.4,9-475-20c-151.1-14.6-224.7-14.7-257-70 C-39.4,384.3-45.8,326-17.5,298.3z"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_7_",
  d: "M85.5,355c65.1,12.3,142.6,18,164,15c61.3-8.5,122.3-22.8,172-25c62.3-2.8,195.1,41.9,288-1 c46.4-21.4,65.1-48,70-68c6.9-28-5.7-56.1-16-72c-29.4-45.5-89.3-62.9-146-58c-13.7-56.9-50.2-109.4-106-133 c-78.2-33.1-180.3-2.4-239,83c-22.3-13.6-47.4-20.3-72-16c-48.5,8.5-91,59.3-95,130c-23.2-13.3-53.1-17.8-76-4 c-36,21.7-36.1,78.7-16,110C30.9,343.1,62.4,350.6,85.5,355z"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "stcloud14",
  d: "M32.2,378.4c70,29,150.3,51.7,181,54c79.1,5.9,132.3-7.5,211-17c83.5-10.1,246.4-29.7,282-26 c13.9,1.5,57.3,6.9,82-19c23.5-24.6,24.9-72.2,7-84c-21.2-14-76.3,38.6-128,47c-28.5,4.6-66.4,4.9-110-2 c-39.3-6.2-59.2-22.1-99-24c-73.7-3.6-103.6,43.8-174,33c-20.3-3.1-45.2-17.2-76-16c-26.6,1-37.4,12.5-64,14 c-54.3,3.1-90.1-45.9-137-32c-15.2,4.5-32.4,15.5-33,28C-26.7,351.4,3.1,366.4,32.2,378.4z"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_1_"
});

var SvgCloud1 = function SvgCloud1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cloud_2_Clip_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 781.5 370.8",
    style: {
      enableBackground: "new 0 0 781.5 370.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Cloud_2_Clip_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud_2_Clip_2"
  }, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "Cloud_2_Clip_6"
  }, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref5), /*#__PURE__*/React.createElement("g", {
    id: "Cloud_2_Clip_5"
  }, _ref6, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _ref7), /*#__PURE__*/React.createElement("g", {
    id: "Cloud_2_Clip_4"
  }, _ref8, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _ref9), /*#__PURE__*/React.createElement("g", {
    id: "Cloud_2_Clip_3"
  }, _ref10, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _ref11))), _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloud1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cloud1.de2f4468.svg";
export { ForwardRef as ReactComponent };